// utils/superAdmins.js
// The portal-wide super-admin lists, kept hardcoded to match the Blazor app.
//
// These were copy-pasted into five files (Sidebar, formsedit, formsglobal,
// formsimport, iconlibrary); they now live here once.
//
// ⚠ There are FOUR distinct hardcoded ID lists in this app and they are NOT
// interchangeable:
//
//   • SUPER_ADMIN_IDS — SEVEN IDs — the sidebar's super-admin section
//     (legacy Shared/NavMenu.razor L251-258) and the Icon Library route guard
//   • GLOBAL_LIBRARY_ADMIN_IDS — SIX IDs — the Global Forms tab and checkbox
//     (Pages/Forms/Forms.razor L47-56, FormsEdit / FormsGlobal / FormsImport)
//     and the Icon Library's IsPowerUser (IconLibrary.razor.cs L146-152).
//     The seven minus lyle.koegler.
//   • the TWO-ID UAS gate            — utils/uas.js   (isUasSpecialUser)
//   • the EIGHT-ID Intel gate        — utils/intel.js (isIntelUser)
//
// They overlap, which makes merging them look tempting and safe. It is not:
// collapsing them would silently widen or narrow who can reach each module.
// superAdmins.test.js parses the legacy razor files at test time and asserts
// each list's membership precisely so that refactor fails loudly.

// Legacy NavMenu.razor L251-258, in that order.
export const SUPER_ADMIN_IDS = [
    '5555555@internal.fire.lacounty.gov',
    '2222222@internal.fire.lacounty.gov',
    '1111111@internal.fire.lacounty.gov',
    '3333333@internal.fire.lacounty.gov',
    '0000000@internal.fire.lacounty.gov',
    'lyle.koegler@fire.lacounty.gov',
    '451786@internal.fire.lacounty.gov',
];

// Legacy Forms.razor L47-56, in that order. Audit 12r (8 Sep 2026): the
// global-library pages read SUPER_ADMIN_IDS until the seventh nav ID was
// added — the two lists had matched by coincidence, and the legacy forms /
// icon-library pages never listed lyle.koegler.
export const GLOBAL_LIBRARY_ADMIN_IDS = [
    '2222222@internal.fire.lacounty.gov',
    '5555555@internal.fire.lacounty.gov',
    '1111111@internal.fire.lacounty.gov',
    '3333333@internal.fire.lacounty.gov',
    '0000000@internal.fire.lacounty.gov',
    '451786@internal.fire.lacounty.gov',
];

export function isSuperAdmin(user) {
    return !!user?.id && SUPER_ADMIN_IDS.includes(user.id);
}

export function isGlobalLibraryAdmin(user) {
    return !!user?.id && GLOBAL_LIBRARY_ADMIN_IDS.includes(user.id);
}
